import { restApi } from '../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'

const statusSolicitacoesRepository = createRepository({
  path: 'status-solicitacoes',
  restApi
})

statusSolicitacoesRepository.getStatusFinais = () => {
  return restApi.get('status-finais-solicitacoes')
}

statusSolicitacoesRepository.getFontesLiberacao = () => {
  return restApi.get('fontes-liberacao-solicitacoes')
}

export default statusSolicitacoesRepository
